export default "__VITE_ASSET__DCk42Gqs__"